import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconMehrBettZimmer = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconMehrBettZimmer",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M8.21 3.76v.2H2V2.58c0-.33.26-.59.59-.59h3.86c.97 0 1.76.79 1.76 1.76m6.4 1.37H2v6.01h1.17v-1.4h11.45zm-6.4 8.94c0-.97-.79-1.76-1.76-1.76H2v1.96h6.21zm6.4 1.37H2v5.9a.59.59 0 1 0 1.17 0v-1.3h11.45zm6.22-11.6a.59.59 0 0 1 1.17 0v17.5a.59.59 0 1 1-1.17 0v-1.3h-3.87v1.3a.59.59 0 1 1-1.17 0V3.84a.59.59 0 1 1 1.17 0v1.29h3.87zm-3.87 15.04h3.87V16.6h-3.87zm0-3.44h3.87v-2.27h-3.87zm0-3.44h3.87V9.73h-3.87zm0-3.44h3.87V6.3h-3.87z"
  })
}));